import { render, staticRenderFns } from "./BoardWorkcenter.vue?vue&type=template&id=73831a06&scoped=true&"
import script from "./BoardWorkcenter.vue?vue&type=script&lang=js&"
export * from "./BoardWorkcenter.vue?vue&type=script&lang=js&"
import style0 from "./BoardWorkcenter.vue?vue&type=style&index=0&id=73831a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73831a06",
  null
  
)

export default component.exports